module.exports = __webpack_public_path__ + "static/img/banner1.4e7c59f1.png";